module.exports = __webpack_public_path__ + "static/media/firmware.ad0e3963.jpg";